module.exports = __webpack_public_path__ + "img/address-icon.7780ca9c.png";